import React from 'react';
import { useSelector } from 'react-redux';
import GlobalLoader from '../../admin/shared/globalLoader';
import { Navigate } from 'react-router-dom';
import { getUser, setReturnURL} from '../../../utils/commonfunction';
import { ROLE } from "../../../utils/Constants";

const UserPublicRoute = ({ component: Component }) => {
    // const loaderState = useSelector((state) => state.globalLoader);
    // return (
    //     <>
    //         {
              
    //                 loaderState ?
    //                     <GlobalLoader /> :
    //                     <Component />
    //         }
    //     </>
    // )
    const userData = getUser(ROLE.USER)
    return (
        <>
            {(function(){
                if(Object.keys(userData).length && userData.token){
                    setReturnURL(ROLE.USER);
                    return <Navigate to="/user/favourites"/>
                }else{
                    return  <Component />
                }
            })()}
        </>
    )
}

export default UserPublicRoute;